module.exports = __webpack_public_path__ + "img/table.c5ad93dd.png";